(function () {
  var panel = document.getElementById('cart-notification');
  var root = document.querySelector('[data-mt-upsell]');
  if (!panel || !root) return;

  var bloqueEnvio = root.querySelector('[data-mt-envio-bloque]');
  var envioId = bloqueEnvio ? Number(bloqueEnvio.getAttribute('data-mt-envio-id')) : null;
  var totalEl = root.querySelector('[data-mt-total]');
  var okEl = root.querySelector('[data-mt-envio-ok]');
  var radios = root.querySelectorAll('input[name="mt-envio"]');

  function dinero(cents, moneda) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: moneda }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function actualizarBurbuja(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var destino = document.getElementById('cart-icon-bubble');
    if (!destino) return;
    var nodo = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
    if (nodo) destino.innerHTML = nodo.innerHTML;
  }

  function refrescar() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (totalEl) totalEl.textContent = dinero(cart.total_price, cart.currency);

        var hayEnvio = envioId && cart.items.some(function (i) { return i.variant_id === envioId; });
        var fisicos = cart.items.some(function (i) { return i.requires_shipping; });

        if (bloqueEnvio) {
          bloqueEnvio.hidden = !fisicos;
          radios.forEach(function (r) { r.checked = (r.value === 'rapido') === !!hayEnvio; });
          if (okEl) okEl.hidden = !hayEnvio;
        }
        return cart;
      })
      .catch(function () {});
  }

  function anadir(id, boton) {
    if (boton) { boton.disabled = true; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-icon-bubble' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        actualizarBurbuja(data.sections);
        if (boton) {
          boton.textContent = 'Añadido ✓';
          boton.classList.add('mt-up-hecho');
          setTimeout(function () {
            boton.textContent = 'Añadir';
            boton.classList.remove('mt-up-hecho');
            boton.disabled = false;
          }, 1600);
        }
        return refrescar();
      })
      .catch(function () { if (boton) boton.disabled = false; });
  }

  function quitarEnvio() {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(envioId), quantity: 0, sections: 'cart-icon-bubble' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { actualizarBurbuja(data.sections); return refrescar(); })
      .catch(function () {});
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mt-add-aroma]');
    if (btn) {
      e.preventDefault();
      anadir(Number(btn.getAttribute('data-mt-add-aroma')), btn);
    }
  });

  radios.forEach(function (r) {
    r.addEventListener('change', function () {
      if (!envioId) return;
      if (r.value === 'rapido' && r.checked) anadir(envioId, null);
      if (r.value === 'estandar' && r.checked) quitarEnvio();
    });
  });

  // Refresca el resumen cada vez que se abre el panel
  new MutationObserver(function () {
    if (panel.classList.contains('active')) refrescar();
  }).observe(panel, { attributes: true, attributeFilter: ['class'] });

  refrescar();
})();
